<h1 mat-dialog-title>An error has occurred!</h1>
<mat-dialog-content>
	<p *ngIf="data.status">
		<b>Status Code: {{data.status}}</b>
	</p>
	<p>
		Please contact admin or else try again later
	</p>

	<!-- <div class="text-center">
		<img width="100" src="./../../../../assets/images/globalError.svg" alt="">
		<div class="error-message"> Something went wrong. Please try again later</div>
	</div> -->

	<p class="error-message">
		<!-- {{data.message}} -->
		Something Went Wrong . Please Try again later
	</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button class="btn-primary" mat-dialog-close>
		Close
	</button>
</mat-dialog-actions>